// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const BodyTypeSchema = z.enum(['NONE','HTML','JSON','XML','SOAP','FORM_DATA','MULTIPART_FORM_DATA','TEXT','GRAPHQL','PROTOBUF','UNKNOWN'] as const);

export type BodyTypeType = `${z.infer<typeof BodyTypeSchema>}`

export default BodyTypeSchema;
